import { useQuery } from "react-query";
import {
	fetchAnnouncements,
	fetchGlobalAnnouncement,
} from "../queries/announcements.queries";
import { PaginatedFilter } from "../types/axios.types";

export const useGlobalAnnouncement = () => {
	return useQuery({
		queryKey: ["announcement", "global"],
		queryFn: () => fetchGlobalAnnouncement(),
	});
};

export const useAnnouncements = (
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
) => {
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const query = useQuery(
		["announcements", page, size, search, filters, sortBy],
		() => {
			try {
				return fetchAnnouncements(page, size, search, filters, sortBy);
			} catch (err) {
				return null;
			}
		},
		{ keepPreviousData: true },
	);
	return query?.data;
};
